module.exports = __webpack_public_path__ + "static/Runa HR-7b894bfd0da692e6553d53bf4e840827.jpg";